(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["FAQ-template"]) return;
  try {
    

$( document ).ready(function() {
  $(".content_askeds a:first").trigger("click"); 
});



  } catch(e) { console.error(e); }
})();
      })();
